import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames'
import i18next from 'i18next'
import {languages} from '../i18n.js'
import { useLocation, BrowserRouter } from "react-router-dom";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Col from 'react-bootstrap/Col';
import ShareModal from './ShareModal.jsx';
import   { useEffect }  from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../App.css'; 
import { Row } from 'react-bootstrap';
import '../styles/NavBar.css'; 


function MultilanguageNavigationBar(props) {
    const { t } = useTranslation()
    const location = useLocation()
    const urlPart = 
      location.pathname !== undefined && 
      location.pathname.includes("/countries") ? 
      location.pathname.substring(location.pathname.lastIndexOf("/countries") + 1).length > 10 ? 
     "countries" : "countries" : 
    location.pathname.split("/").slice(3).join("/");




    useEffect(() => {
     
     
    }, [props.lang])
   
    
    

    return  <React.Fragment>
  
      <div className="menu-container">
      

        <Row>  
          <Col className="col-sm-8">
      <Navbar.Brand href="https://www.fao.org/home/en" target="_blank"><img key={props.lang} height='60px' style={{marginTop:"1rem"}}src={`https://www.fao.org/images/corporatelibraries/fao-logo/fao-logo-archive/fao-logo-blue-2lines-${props.lang}.svg`} alt="FAO logo"/></Navbar.Brand>
      </Col>
      <Col className="col-sm-4 align-self-center">
        <Row className='d-flex justify-content-end'>
        <Navbar  className='d-flex justify-content-end' >
        <Navbar.Collapse className='d-flex justify-content-end' >
        <NavDropdown   title={
        <span>
           {props.langTitle} <img  src={process.env.PUBLIC_URL + `/img/chevron-down-blue.svg`} alt="arrow down icon" />
        </span>
    }  className="basic-nav-dropdown ">

{languages.map(({ code, name }) => (
 <NavDropdown.Item key={code} 
    href={`/silvagris/${code}/${urlPart}`}
     className={classNames('basic-nav-dropdown', {
       disabled: props.lang === code,
     })}
     onClick={() => {
       i18next.changeLanguage(code)
     }}
   >
     {name} </NavDropdown.Item>
  
  
))}
 
 </NavDropdown>
 {/* <img className="top-bar-icon" src={process.env.PUBLIC_URL + `/img/search.svg`} alt="search icon" /> */}
 <ShareModal/>
        </Navbar.Collapse>
        </Navbar>
        </Row>
        </Col>
        
     
        </Row>
        </div>
        <div style={{ height: "50px", boxShadow: "0 20px 20px -20px #9d9a9a"}}></div>
        <Col className="menu-container">
  <Row ><div className="title-style"><p className="website-title">{t('website_title')}</p></div></Row>
  <Navbar collapseOnSelect expand="lg" style={{paddingTop:"10px", borderBottom:"1px solid #F2F2F2"}} /* bg="light" variant="light" */ >
   
     
     
    
     
        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{paddingTop:"0px", paddingLeft:"0rem", paddingRight: "0rem"}} />
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-start">
        <Nav  className="me-auto">
        <Nav.Link style={{ paddingLeft:"0rem"}} href={`/silvagris/${props.lang}`}><img className="home-icon" src={process.env.PUBLIC_URL + `/img/house-orange.svg`} alt="home icon" /></Nav.Link>
        <NavDropdown title={
        <span>
          {t('menu_item_about')} <img style={{verticalAlign: "middle"}} src={process.env.PUBLIC_URL + `/img/chevron-down-grey.svg`} alt="arrow down icon" />
        </span>} id="basic-nav-dropdown">
              <NavDropdown.Item href={`/silvagris/${props.lang}/about/background`}>{t('menu_item_background')}</NavDropdown.Item>
              <NavDropdown.Divider style={{marginRight: "0.5rem", marginLeft: "0.5rem"}}/>
              <NavDropdown.Item href={`/silvagris/${props.lang}/about/monitoring-framework`}>
              {t('monitoring_framework')}
              </NavDropdown.Item>
             </NavDropdown>
             <NavDropdown title={
        <span>
          {t('menu_item_data')} <img  src={process.env.PUBLIC_URL + `/img/chevron-down-grey.svg`} alt="arrow down icon" />
        </span>} id="basic-nav-dropdown">
              <NavDropdown.Item href={`/silvagris/${props.lang}/data/policies-responses/global`}>{t('policies_responses')}</NavDropdown.Item>
              <NavDropdown.Divider style={{marginRight: "0.5rem", marginLeft: "0.5rem"}}/>
              <NavDropdown.Item href={`/silvagris/${props.lang}/data/species/global-regional-coverage`}>
              {t('menu_item_species')}
              </NavDropdown.Item>
             </NavDropdown>
            <Nav.Link href={`/silvagris/${props.lang}/countries`}>{t('menu_item_countries')}</Nav.Link>
            <Nav.Link href={`/silvagris/${props.lang}/organizations`}>{t('organisations')}</Nav.Link>
            <Nav.Link  href={`/silvagris/${props.lang}/glossary`}>{t('menu_item_glossary')}</Nav.Link>
            <NavDropdown title={
        <span>
          {t('menu_item_resources')} <img  src={process.env.PUBLIC_URL + `/img/chevron-down-grey.svg`} alt="arrow down icon" />
        </span>} id="basic-nav-dropdown">
        <NavDropdown.Item href={`/silvagris/${props.lang}/resources/publications`}>{t('menu_item_publications')}</NavDropdown.Item>
        <NavDropdown.Divider style={{marginRight: "0.5rem", marginLeft: "0.5rem"}}/>
              <NavDropdown.Item href={`/silvagris/${props.lang}/resources/learning`}>{t('menu_item_learning')}</NavDropdown.Item>
              <NavDropdown.Divider style={{marginRight: "0.5rem", marginLeft: "0.5rem"}}/>
              <NavDropdown.Item href={`/silvagris/${props.lang}/resources/external-resources`}>{t('external_resources')} </NavDropdown.Item>
              <NavDropdown.Divider style={{marginRight: "0.5rem", marginLeft: "0.5rem"}}/>
              <NavDropdown.Item href={`/silvagris/${props.lang}/resources/networks`}>{t('menu_item_networks')}</NavDropdown.Item>
             </NavDropdown>
           
            </Nav>


            </Navbar.Collapse>
           
    </Navbar>
    </Col>

  </React.Fragment>;
  }

  export default MultilanguageNavigationBar;